import React from "react";

export default function Smile(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
			<g id="ic_sentiment_satisfied_24px" transform="translate(-2 -2)">
				<circle
					id="Ellipse_27"
					data-name="Ellipse 27"
					cx="1"
					cy="1"
					r="1"
					transform="translate(11 7)"
					fill="#32a8a4"
				/>
				<circle
					id="Ellipse_28"
					data-name="Ellipse 28"
					cx="1"
					cy="1"
					r="1"
					transform="translate(6 7)"
					fill="#32a8a4"
				/>
				<path
					id="Path_106"
					data-name="Path 106"
					d="M9.493,2A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.493,2ZM9.5,15.5a6,6,0,1,1,6-6A6,6,0,0,1,9.5,15.5Zm0-3A3,3,0,0,1,6.913,11H5.66a4.121,4.121,0,0,0,7.68,0H12.087A3,3,0,0,1,9.5,12.5Z"
					fill="#32a8a4"
				/>
			</g>
		</svg>
	);
}

export function SmileLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="65.5" height="65.5">
			<g transform="translate(.75 .75)" fill="#32a8a4">
				<circle data-name="Ellipse 28" cx="3.683" cy="3.683" r="3.683" transform="translate(17.884 21.268)" />
				<circle data-name="Ellipse 55" cx="3.683" cy="3.683" r="3.683" transform="translate(38.884 21.268)" />
				<path
					data-name="Path 106"
					d="M31.968 0A32 32 0 1 0 64 32 31.984 31.984 0 0 0 31.968 0ZM32 57.6A25.6 25.6 0 1 1 57.6 32 25.593 25.593 0 0 1 32 57.6Zm0-12.8a12.79 12.79 0 0 1-11.04-6.4h-5.344a17.584 17.584 0 0 0 32.768 0H43.04A12.79 12.79 0 0 1 32 44.8Z"
					stroke="#fff"
					stroke-width="1.5"
				/>
			</g>
		</svg>
	);
}
